import * as Yup from 'yup';

import { Strings } from '@app/constants';

export const addEmployeeSchema = Yup.object()
  .shape({
    personalInfo: Yup.object().shape({
      firstName: Yup.string()
        .trim()
        .required(Strings.validation.fieldRequired(Strings.field.firstName)),
      lastName: Yup.string()
        .trim()
        .required(Strings.validation.fieldRequired(Strings.field.lastName)),
      personalEmail: Yup.string()
        .required(Strings.validation.fieldRequired(Strings.field.personalEmail))
        .email(Strings.validation.invalidEmail),
    }),

    officialInfo: Yup.object().shape({
      roleId: Yup.string().required(Strings.validation.selectRequired(Strings.field.roleName)),
      officialEmail: Yup.string()
        .required(Strings.validation.fieldRequired(Strings.field.officialEmail))
        .email(Strings.validation.invalidEmail)
        .matches(/^[a-zA-Z0-9._%+-]+@syncglob\.com$/, Strings.validation.invalidOfficialEmail),
      joiningDate: Yup.string()
        .nullable()
        .required(Strings.validation.fieldRequired(Strings.field.joiningDate)),
      designation: Yup.string().required(
        Strings.validation.selectRequired(Strings.field.designation)
      ),
      department: Yup.string().required(
        Strings.validation.selectRequired(Strings.field.department)
      ),
      managerId: Yup.array()
        .of(Yup.number().required(Strings.validation.fieldRequired))
        .test(
          'manager',
          Strings.validation.selectRequired(Strings.field.manager),
          function (value) {
            return value && value.length > 0;
          }
        ),
    }),
  })
  .required();
export const addInternSchema = Yup.object()
  .shape({
    source: Yup.string().required(Strings.validation.selectRequired(Strings.field.source)),
    resume: Yup.string().required(Strings.validation.uploadRequired(Strings.field.resume)),
    other: Yup.string()
      .trim()
      .nullable()
      .test(
        'is-Other',
        Strings.validation.fieldRequired(Strings.field.sourceName),
        function (value) {
          const source = this.parent.source;
          if (source === 'Other') {
            return !!value;
          }
          return true;
        }
      ),
    referenceBy: Yup.string()
      .trim()
      .nullable()
      .test(
        'is-Reference',
        Strings.validation.fieldRequired(Strings.field.referenceName),
        function (value) {
          const source = this.parent.source;
          if (source === 'Reference') {
            return !!value;
          }
          return true;
        }
      ),
  })
  .required();
